import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AddPolicyDataService } from './../../../../_services/signup-process-service/add-policy-data.service';
import { UserService } from '../../../../_services/user.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-policy-not-found-screen',
  templateUrl: './policy-not-found-screen.component.html',
})
export class PolicyNotFoundScreenComponent implements OnInit {
  userData: any;
  amountOfTries: number;
  policyHolderName: string;
  policyNumber: string;
  noOfAttempts = 0;
  dateOfBirth: any;
  isAcmic = false;
  zipCode: string;

  constructor(
    private addPolicyDataService: AddPolicyDataService,
    private acmicService: AcmicService,
    private router: Router,
    private userService: UserService
  ) {}

  getObservableData(userData): void {
    this.policyHolderName = `${userData.userDetails.firstName} ${userData.userDetails.middleName} ${userData.userDetails.lastName}`;
    this.policyNumber = `${userData.policyDetail.policynumber.policyNumber}`;
    this.dateOfBirth = `${userData.userDetails.dateOfBirth}`;
    this.zipCode = `${userData.userDetails.zipCode}`;
  }

  goBackAPage(): void {
    this.router.navigate(['signup']);
  }

  updateObservable(userData): void {
    userData.addPolicyAttempts = userData.addPolicyAttempts + 1;
    this.userData = userData;
    this.noOfAttempts = this.userData.addPolicyAttempts;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.userService.$user.subscribe((user) => {
      if (user && !user.addPolicyAttempts) {
        user.addPolicyAttempts = 0;
      }
      this.updateObservable(user);
    });

    this.addPolicyDataService.$newPolicy.subscribe((userData) => {
      this.userData = userData;
    });

    this.getObservableData(this.userData);
  }
}
